import { Add, Delete, Pool, Preview } from '@tunasong/icons'
import type { Track } from '@tunasong/schemas'
import cn from 'classnames'
import type { FC } from 'react'
import styles from './channel-header.module.css'

export interface ChannelHeaderProps {
  className?: string
  selected?: Track
  onToggleDetails(): void
  onNewTrack?(): void
  onTogglePool?(): void
  onDeleteTrack?(track: Track): void
}

export const ChannelHeader: FC<ChannelHeaderProps> = props => {
  const { className, selected, onTogglePool, onDeleteTrack, onNewTrack, onToggleDetails } = props

  return (
    <div className={cn(styles.header, className)}>
      <button className={styles.actionButton} title="Show/Hide Media Pool" onClick={onTogglePool}>
        <Pool className={styles.svg} />
      </button>
      <button className={styles.actionButton} title="Show/Hide Details" onClick={() => onToggleDetails()}>
        <Preview className={styles.svg} />
      </button>
      <button className={styles.actionButton} title="New Track" onClick={onNewTrack}>
        <Add className={styles.svg} />
      </button>
      {selected && (
        <button
          className={cn(styles.actionButton, styles['actionButton--delete'])}
          title="Delete Track"
          onClick={onDeleteTrack ? () => onDeleteTrack(selected) : undefined}
        >
          <Delete className={styles.svg} />
        </button>
      )}
    </div>
  )
}

export default ChannelHeader
